import { ChatPanel } from '../ChatPanel.jsx'
import { SearchTrigger } from '../SearchTrigger.jsx'
import { useChatLayout } from '../../../context/ChatLayoutContext.jsx'
import { getFloatingBubblePanelPlacement, getFloatingLauncherPositionStyle } from '../../../lib/floatingAnchor.js'
import { cn } from '../../../lib/cn.js'

function isInteractiveSearch(conf) {
  return String(conf?.searchBoxType || '').toLowerCase() === 'interactive'
}

/**
 * Floating AI Display search bar — fixed-position search trigger that
 * opens the chat panel (V1 `ChatContainer` floating search portal parity).
 */
export function FloatingSearchLayout({
  conf,
  messages,
  isTyping,
  onSend,
  ochatbot,
  onLeadFormSubmit,
  onOrderStatusResult,
  ...panelRest
}) {
  const { open, toggleChat, closeChat, openChat } = useChatLayout()
  const positionStyle = getFloatingLauncherPositionStyle(conf || {})
  const { wrapperStyle, innerOriginClass } = getFloatingBubblePanelPlacement(conf || {})
  const interactive = isInteractiveSearch(conf)

  return (
    <>
      <div style={positionStyle} className="inline-block">
        <SearchTrigger
          conf={conf}
          open={open}
          interactive={interactive}
          isTyping={isTyping}
          onOpenChat={openChat}
          onToggleChat={toggleChat}
          onSend={onSend}
        />
      </div>
      <div style={wrapperStyle}>
        <div
          data-state={open ? 'open' : 'closed'}
          className={cn(
            innerOriginClass,
            'h-[560px] w-[380px] max-h-[calc(100vh-7rem)] max-w-[calc(100vw-2rem)]',
            'rounded-[var(--radius-widget)] overflow-hidden border border-[var(--color-border)] shadow-[var(--shadow-widget)]',
            'transition-[transform,opacity] duration-200 ease-out',
            open
              ? 'pointer-events-auto scale-100 opacity-100'
              : 'pointer-events-none scale-95 opacity-0',
          )}
        >
          {open && (
            <ChatPanel
              conf={conf}
              messages={messages}
              isTyping={isTyping}
              onSend={onSend}
              onClose={closeChat}
              ochatbot={ochatbot}
              onLeadFormSubmit={onLeadFormSubmit}
              onOrderStatusResult={onOrderStatusResult}
              {...panelRest}
            />
          )}
        </div>
      </div>
    </>
  )
}
